export default __webpack_public_path__ + "static/asphalte-small-ea176b64f7eff4f9520c3a65e8b4e8c1.png";